/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

import {Button} from '../button-group/button';
export class ButtonInGroupService {
private _changes: Subject<Button> = new Subject<Button>();
/**
 * @return {?}
 */
get changes(): Observable<Button> {
        return this._changes.asObservable();
    }
/**
 * @param {?} button
 * @return {?}
 */
updateButtonGroup(button: Button): void {
        this._changes.next(button);
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonInGroupService_tsickle_Closure_declarations() {
/** @type {?} */
ButtonInGroupService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonInGroupService.ctorParameters;
/** @type {?} */
ButtonInGroupService.prototype._changes;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
